"use client";

import { Dialog, DialogContent, DialogTitle } from "@ui/components/dialog";
import { useTranslations } from "next-intl";

/** 上传缩略图点放大后的全屏预览。图片生成页和视频生成页共用一份。 */
export function UploadPreviewDialog({
	imageUrl,
	onClose,
}: {
	/** null 就是关着 */
	imageUrl: string | null;
	onClose: () => void;
}) {
	const t = useTranslations("aiImageGenerator.client.imageSettings.upload");

	return (
		<Dialog
			open={imageUrl !== null}
			onOpenChange={(open) => !open && onClose()}
		>
			{/* dvh 而不是 100vh：iOS Safari 的 100vh 比可见视口高，配上居中的
			    translateY(-50%) 会把弹窗顶部连同关闭按钮顶到地址栏后面 */}
			<DialogContent
				className="max-w-none w-[100dvw] h-[100dvh] p-0 border-none bg-black/50"
				aria-describedby={undefined}
			>
				<DialogTitle className="sr-only">
					{t("actions.preview")}
				</DialogTitle>
				<div className="relative flex h-full w-full items-center justify-center">
					{/* 铺满屏幕的是 DialogContent 自己而不是 Overlay，Radix 的
					    outside-click 关不掉，所以背景这层得自己接点击。图片盖在
					    它上面，点图片就落不到这里 */}
					<button
						type="button"
						aria-label={t("actions.close")}
						className="absolute inset-0 cursor-default"
						onClick={onClose}
					/>
					{imageUrl && (
						<img
							src={imageUrl}
							alt={t("actions.preview")}
							className="relative max-h-[90dvh] w-auto object-contain"
						/>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
}
